export default {
    PREMIUM: 'PREMIUM',
    REGULER: 'REGULER',
}
